import React, { useState } from 'react';
import { 
    Box, Typography, TextField, Button, List, ListItem, 
    ListItemText, ListItemSecondaryAction, IconButton, 
    Checkbox, Divider, Paper
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { useTranslation } from 'react-i18next';

const TodoList = ({ data = [], updateData }) => {
    const { t } = useTranslation();
    const [task, setTask] = useState('');

    const handleAdd = () => {
        if (!task.trim()) return;
        const newItem = {
            id: Date.now(),
            text: task,
            completed: false,
            createdAt: new Date().toISOString()
        };
        updateData([...data, newItem]);
        setTask('');
    };

    const handleToggle = (id) => {
        updateData(data.map(item => 
            item.id === id ? { ...item, completed: !item.completed } : item
        ));
    };

    const handleDelete = (id) => {
        updateData(data.filter(item => item.id !== id));
    };

    return (
        <Box sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>{t('FamilyManager.Todos.Title', 'Családi teendők')}</Typography>
            
            <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
                <TextField
                    fullWidth
                    label={t('FamilyManager.Todos.NewTask', 'Új teendő')}
                    value={task}
                    onChange={(e) => setTask(e.target.value)}
                    size="small"
                    onKeyPress={(e) => e.key === 'Enter' && handleAdd()}
                />
                <Button 
                    variant="contained" 
                    onClick={handleAdd}
                    startIcon={<AddIcon />}
                >
                    {t('Common.Add', 'Hozzáadás')}
                </Button>
            </Box>

            <Paper variant="outlined">
                <List>
                    {data.map((item, index) => (
                        <React.Fragment key={item.id}>
                            <ListItem>
                                <Checkbox 
                                    checked={item.completed} 
                                    onChange={() => handleToggle(item.id)} 
                                />
                                <ListItemText 
                                    primary={item.text} 
                                    sx={{ 
                                        textDecoration: item.completed ? 'line-through' : 'none',
                                        color: item.completed ? 'text.secondary' : 'text.primary'
                                    }} 
                                />
                                <ListItemSecondaryAction>
                                    <IconButton edge="end" onClick={() => handleDelete(item.id)}>
                                        <DeleteIcon />
                                    </IconButton>
                                </ListItemSecondaryAction>
                            </ListItem>
                            {index < data.length - 1 && <Divider />}
                        </React.Fragment>
                    ))}
                    {data.length === 0 && (
                        <ListItem>
                            <ListItemText 
                                primary={t('FamilyManager.Todos.Empty', 'Nincs még teendő a listában.')} 
                                sx={{ textAlign: 'center', color: 'text.secondary', py: 2 }}
                            />
                        </ListItem>
                    )}
                </List>
            </Paper>
        </Box>
    );
};

export default TodoList;
